import {ActionType} from '../actions'

const reducer = (state = null, action) => {
  switch (action.type) {
    case ActionType.ERR:
      return {message: action.payload.message}

    case ActionType.CLEAR_ERR:
      return null

    default:
      return state
  }
}

export default reducer
